<template>
  <div class="widget-lock-comp">
    <div class="lock-section">
      <a
        :href="
          `${broker_data.link}/login?widget_access=${broker_data.widget_access}&brokerId=${broker_data.id}&bl_api_integrated=${broker_data.bl_api_integrated}`
        "
        target="_blank"
      >
        <div class="text-center login-card">
          <div class="login-red-txt">
            Login for more
          </div>

          <img src="../../assets/images/Login Icon (1).svg" alt="" />
          <br />
          <el-button size="mini" class="login-btn">
            <i class="el-icon-lock"></i> Login</el-button
          >
        </div>
      </a>
    </div>
  </div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { WidgetHelperCallBack } from "../../mixins/WidgetCommonFunctions";

export default {
  name: "LockComponent",
  mixins: [WidgetHelperCallBack],

  data() {
    return {};
  },
  mounted() {},
  created() {
  },
  methods: {},
  computed: {},
};
</script>

<style lang="scss" scoped>
@import "../../css/variable.scss";
@import "../../css/common.scss";

.widget-lock-comp {
  .lock-section {
    position: absolute;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: #fffffffa;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    a {
      text-decoration: none;
    }
    .login-red-txt {
      color: red;
      font-weight: 600;
      font-size: 17px;
      margin-bottom: 10px;
    }
    .login-btn {
      width: 170px;
      border-radius: 7px;
      color: #2d2e8d;
      border: 1px solid;
      margin-top: 5px;
      font-size: 15px;
    }
  }
}
</style>
<style lang="scss">
@import "../../css/variable.scss";
@import "../../css/common.scss";

.widget-lock-comp {
  .login-card {
    width: 400px;
    .el-card {
      border-radius: 8px;
    }
    .el-card__body {
      padding: 30px 20px;
    }
  }
  .mobile-verification-dialog {
    .el-dialog {
      border-radius: 10px;
      width: 500px;
    }

    .el-dialog__header {
      background-color: $secondary-theme-color;
      border-radius: 10px 10px 0 0;
      text-align: center;
      padding: 20px;
    }

    .el-dialog__title {
      color: #ffff;
      font-weight: 600;
    }

    .top-head {
      font-size: 14px;
      color: #000;
      font-weight: 500;
    }

    .norml-txt {
      font-size: 15px;
      color: #000;
      font-weight: 600;
    }

    .el-input__inner {
      border: none;
      border-bottom: 1px solid gray;
      border-radius: 0;
      text-align: center;
      color: #000;
      font-weight: 600;
    }

    .el-dialog__body {
      padding: 30px;
    }

    .otp-btn {
      // border-radius: 4px;
      margin-top: 50px;
      font-weight: 600;
      padding: 10px 30px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #ffffff;
    }
  }
}

@media screen and (max-width: 455px) {
  .widget-lock-comp {
    .lock-section {
      width: 100%;
    }
    .login-card {
      width: 100%;
    }
  }
}
</style>
